import styled from 'styled-components';
import { SingleSelect } from '@ibinder/ui-common-core';

export const SelectContainer = styled.div`
  padding: 0.75rem;
`;

export const Select = styled(SingleSelect)`
  width: 15.625rem;
`;
